// import { conceptMappingMessagesEn } from '@verantos-dev/feature-concept-mapping';
// import { datasetDeliveryMessagesEn } from '@verantos-dev/feature-dataset-delivery';
import {
  rolesEn,
  coreAnnotationToolSidebarMessagesEn,
  workspaceCommonMessagesEn,
} from '@verantos-dev/core-annotation-tool';
import { appLayoutMessagesEn, enterpriseLoginMessagesEn } from '@verantos-dev/core-localization';
import { annotationDashboardMessagesEn } from '@verantos-dev/feature-annotation-dashboard';
import { metricsMessagesEn } from '@verantos-dev/feature-annotation-metrics';
import {
  adminCommonMessagesEn,
  adminProjectsMessagesEn,
  createProjectWizardMessagesEn,
  generateAccuracyMessagesEn,
} from '@verantos-dev/feature-annotation-project-admin';
import { annotationScreenMessagesEn } from '@verantos-dev/feature-annotation-screen';
import { annotatorProjectsMessagesEn } from '@verantos-dev/feature-annotator-projects';
import { annotatorQueueMessagesEn } from '@verantos-dev/feature-annotator-queue';
import { supervisorProjectsMessagesEn } from '@verantos-dev/feature-supervisor-projects';
import { supervisorQueueMessagesEn } from '@verantos-dev/feature-supervisor-queue';
import { supervisorScreenMessagesEn } from '@verantos-dev/feature-supervisor-screen';
import { dataGridMessagesEn } from '@verantos-dev/shared-components';
import { curationPlatformNavMessagesEn } from '@verantos-dev/shared-layout';

export default {
  // CORE MESSAGES
  ...rolesEn,
  ...appLayoutMessagesEn,
  ...enterpriseLoginMessagesEn,

  // Annotation Tool keys with no counterpart in @verantos-dev/core-localization.
  'appHeader.feature.sectionTitle.annotator-queue': 'Annotator Workspace',
  'appHeader.feature.sectionTitle.annotation-dashboard': 'Annotation Dashboard',
  'appHeader.feature.sectionTitle.annotation-supervisor': 'Supervisor Workspace',
  'appHeader.feature.sectionTitle.admin-projects': 'Manage Projects',
  // Rendered by LandingPage when the signed-in user has no allowed apps.
  'authenticatedPage.noAccessMessage':
    'You do not have access to any application. Please contact your administrator.',

  ...dataGridMessagesEn,
  ...curationPlatformNavMessagesEn,

  // FEATURE MESSAGES
  ...coreAnnotationToolSidebarMessagesEn,
  ...annotationDashboardMessagesEn,
  ...annotatorQueueMessagesEn,
  ...annotationScreenMessagesEn,
  ...supervisorQueueMessagesEn,
  ...supervisorScreenMessagesEn,
  ...workspaceCommonMessagesEn,
  ...createProjectWizardMessagesEn,
  ...adminProjectsMessagesEn,
  ...adminCommonMessagesEn,
  ...annotatorProjectsMessagesEn,
  ...supervisorProjectsMessagesEn,
  ...metricsMessagesEn,
  ...generateAccuracyMessagesEn,
};
